import { BaseService } from "core/services";
import { FacilityOrderProductRouteService } from "application/facility-order/services";

class FacilityOrderProductService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityOrderProductRouteService());
	}

	upsert(resource) {
		const url = this.routeService.upsert(resource);
		return this.apiClient.post(url, resource);
	}
}

export default FacilityOrderProductService;
